import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UserProfile from "./templates/userprofile";
import Signup from "./templates/signup";
import Logout from "./templates/logout";
import Leaderboard from "./templates/leaderboard";
import Compete from "./templates/compete";
import Competes from "./templates/competes";
import Account from "./templates/account";
import Home from "./templates/home";
import Login from "./templates/login";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./state/store";
import { ForgotPassword } from "./templates/forgot-password/ForgotPassword";
import { ResetPass } from "./templates/reset-password/ResetPassword";
import { ConnectionProvider } from './contexts/ConnectionContext';
import ConnectionStatusOverlay from './components/canvas/ConnectionStatusOverlay/ConnectionStatusOverlay';
import { useConnection } from './contexts/ConnectionContext';
import { Capacitor } from '@capacitor/core';
// import FullScreenPromptModal from "./components/fullscreenpromptmodal/FullScreenPromptModal";
import IOSUpdatePrompt from './components/app-update/IOSUpdatePrompt';

const AppContent: React.FC = () => {
  const { isOffline } = useConnection();

  const handleReload = () => {
    if (Capacitor.isNativePlatform()) {
      // For native platforms, use Capacitor's App API
      const url = window.location.href
      window.location.href = url;
    } else {
      // For web platforms, use standard reload
      window.location.reload();
    }
  };

  return (
    <ReduxProvider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/userprofile/:userId" element={<UserProfile />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/compete/:drawingField" element={<Compete />} />
          <Route path="/competes" element={<Competes />} />
          <Route path="/account/*" element={<Account />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgotpassword/link" element={<ForgotPassword />} />
          <Route path="/reset/:resetPasswordToken" element={<ResetPass />} />
        </Routes>
        <IOSUpdatePrompt />
        {isOffline && <ConnectionStatusOverlay onRetry={handleReload} />}
      </Router>
    </ReduxProvider>
  );
};

const App: React.FC = () => {
  return (
    <ConnectionProvider>
      <AppContent />
    </ConnectionProvider>
  );
};

export default App;
